import {createContext} from 'react';
import defaultClient from 'src/internal/revamp/config/defaultClient';

import type {DataClient} from 'src/internal/revamp/config/types';

const DataClientContext = createContext<DataClient | {}>(defaultClient);

export default DataClientContext;
